export class LongStayAlertSetting{
  companyId?: string;
  maxStayDurationSeconds?: number;

  constructor(params?: Partial<LongStayAlertSetting>) {
    Object.assign(this, params);
  }
}